import { useEffect } from 'react';
import { useLocation } from 'react-router';

const ScrollToTop = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // If we just navigated after creating a job, skip automatic scrolling.
    // The Job page sets `location.state.justCreated = true` when it navigates
    // from "new" to the real job id. Clear that flag in history so this only
    // applies once.
    // console.log("ScrollToTop: checking justCreated flag", location.state);
    if (location.state && location.state.justCreated) {
      // console.log("ScrollToTop: skipping scroll due to justCreated flag");
      try {
        const newState = { ...location.state };
        delete newState.justCreated;
        // Replace history state to avoid skipping scroll on subsequent navigation
        window.history.replaceState(newState, document.title);
      } catch (e) {
        console.warn("ScrollToTop: could not clear justCreated state", e);
        // ignore
      }
      return;
    }

    // Scroll the window
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

    // Also scroll the main content area (for MainLayout)
    const mainContent = document.querySelector('.MainContent');
    if (mainContent) {
      mainContent.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }

    // Fallback: find any scrollable containers
    // const scrollableElements = document.querySelectorAll('[style*="overflow: auto"], [style*="overflow-y: auto"], [style*="overflow-y: scroll"]');
    // scrollableElements.forEach((element) => {
    //   element.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    // });
  }, [location.pathname, location.search, location.state]);

  return children;
};

export default ScrollToTop;
